export default __webpack_public_path__ + "static/media/presentation-icon.1d12b0ec.svg";